var _defs, _circle, _circle2, _g, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolkswagenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Volkswagen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vw-inner"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.6
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#001E50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.6,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vw-inner)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    strokeLinejoin: "miter",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8,0.3 L8,7.9 L12.2,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.6 L5.5,14.1 L8,10 L10.5,14.1 L16,0.6"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagenCircle);
export default __webpack_public_path__ + "static/media/volkswagen-circle.0d2edb36dfabafc4316f8c1a7a94dc16.svg";
export { ForwardRef as ReactComponent };